module.exports = __webpack_public_path__ + "img/ke.107dca85.svg";